(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soodam-category-bar"] && !Shopify.designMode) return;
  try {
    
  // Toggles the edge-fade masks as the row scrolls; the fade only shows
  // on a side where more categories are actually hidden. Named with the
  // soodam- prefix because Horizon's scrolling.js already registers a
  // 'scroll-hint' element with different behavior.
  class SoodamScrollHint extends HTMLElement {
    // Overflow below this many pixels is treated as fully visible, so a
    // fade never ghosts a label to hide a sliver.
    static overflowThreshold = 24;

    connectedCallback() {
      this.update = this.update.bind(this);
      this.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this);
      this.centerCurrent();
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    // Park the current category in view on arrival, without smooth
    // scrolling (instant, so no reduced-motion concern) and without
    // touching the page's vertical scroll position.
    centerCurrent() {
      const current = this.querySelector('.soodam-catbar__link--current');
      if (!current) return;
      const target = current.offsetLeft + current.offsetWidth / 2 - this.clientWidth / 2;
      this.scrollLeft = Math.max(0, Math.min(target, this.scrollWidth - this.clientWidth));
    }

    update() {
      const max = this.scrollWidth - this.clientWidth;
      const overflowing = max >= SoodamScrollHint.overflowThreshold;
      this.toggleAttribute('data-overflow-start', overflowing && this.scrollLeft > 1);
      this.toggleAttribute('data-overflow-end', overflowing && this.scrollLeft < max - 1);
    }
  }

  if (!customElements.get('soodam-scroll-hint')) {
    customElements.define('soodam-scroll-hint', SoodamScrollHint);
  }

  } catch(e) { console.error(e); }
})();
})();
